import React from 'react';

import { EquipmentBulkEditView } from '@/features/equipment-browser/equipment-bulk-edit/equipment-bulk-edit-view';
import { useEquipmentBulkEditLoader } from '@/features/equipment-browser/equipment-bulk-edit/hooks/use-equipment-bulk-edit-loader';

type EquipmentBulkEditDrawerProps = {
  onClose: () => Promise<void>;
};

export const EquipmentBulkEditDrawer = ({
  onClose,
}: EquipmentBulkEditDrawerProps): React.ReactNode => {
  const { bulkEditView, deviceKind } = useEquipmentBulkEditLoader();

  if (!bulkEditView || !deviceKind) {
    return null;
  }

  return <EquipmentBulkEditView onClose={onClose} bulkEditView={bulkEditView} />;
};
